/*import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { GanttChart } from "./GanttChart";
import { GanttWorkItem } from "../../types/gantt";
import { ProjectAPI } from "../../api/apiClient";

export default function GanttStandalone() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const projectName = params.get("projectName");

  const date = params.get("date");
  const projectId = params.get("projectId");

  const [items, setItems] = useState<GanttWorkItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectId || !date) return;

    const loadData = async () => {
      try {
        const res = await ProjectAPI.getGantt(
          Number(projectId),
          date
        );
        setItems(res);
      } catch (err) {
        console.error("Gantt load failed", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [projectId, date]);

  if (loading) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        Loading Gantt...
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        No Gantt data available
      </div>
    );
  }

  return (
    <div className="w-screen h-screen overflow-hidden bg-white">
      <GanttChart
        items={items}
       // projectName={`Project ${projectId}`}
       projectName={projectName || `Project ${projectId}`}
      />
    </div>
  );
}*/
/*import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { GanttChart } from "./GanttChart";
import { GanttWorkItem } from "../../types/gantt";
import { ProjectAPI } from "../../api/apiClient";

export default function GanttStandalone() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const projectName = params.get("projectName");
  const date = params.get("date");
  const projectId = params.get("projectId");

  const [items, setItems] = useState<GanttWorkItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!projectId || !date) return;

    const loadData = async () => {
      try {
        const res = await ProjectAPI.getGantt(
          Number(projectId),
          date
        );

        setItems(res);
      } catch (err) {
        console.error("Gantt load failed", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [projectId, date]);

  if (loading) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        Loading Gantt...
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        No Gantt data available
      </div>
    );
  }

  return (
    <div className="w-screen h-screen overflow-hidden bg-white">
      <GanttChart
        items={items}
        projectName={projectName || `Project ${projectId}`}
        asOnDate={date || ""}
      />
    </div>
  );
}*/

/*import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { GanttChart } from "./GanttChart";
import { GanttWorkItem } from "../../types/gantt";
import { ProjectAPI } from "../../api/apiClient";

type GanttPdfPayload = {
  frontendUrl?: string;
  projectName: string;
  asOnDate: string;
  showPlanned: boolean;
  showActual: boolean;
  showForecast: boolean;
  expandedIds: number[];
  items: GanttWorkItem[];
};

export default function GanttStandalone() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [items, setItems] = useState<GanttWorkItem[]>([]);
  const [projectName, setProjectName] = useState<string>("");
  const [asOnDate, setAsOnDate] = useState<string>("");
  const [showPlanned, setShowPlanned] = useState(true);
  const [showActual, setShowActual] = useState(true);
  const [showForecast, setShowForecast] = useState(true);
  const [expandedIds, setExpandedIds] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const raw = sessionStorage.getItem("ganttPrintData");

    if (raw) {
      try {
        const parsed = JSON.parse(raw) as GanttPdfPayload;

        setItems(parsed.items || []);
        setProjectName(parsed.projectName || "");
        setAsOnDate(parsed.asOnDate || "");
        setShowPlanned(parsed.showPlanned ?? true);
        setShowActual(parsed.showActual ?? true);
        setShowForecast(parsed.showForecast ?? true);
        setExpandedIds(parsed.expandedIds || []);

        setLoading(false);
        (window as any).__ganttReady = true;
        return;
      } catch (err) {
        console.error("Invalid ganttPrintData", err);
      }
    }

    const projectId = params.get("projectId");
    const date = params.get("date");

    if (!projectId || !date) {
      setLoading(false);
      (window as any).__ganttReady = true;
      return;
    }

    setProjectName(params.get("projectName") || `Project ${projectId}`);
    setAsOnDate(date);

    const loadData = async () => {
      try {
        const res = await ProjectAPI.getGantt(Number(projectId), date);
        setItems(res || []);
      } catch (err) {
        console.error("Gantt load failed", err);
      } finally {
        setLoading(false);
        (window as any).__ganttReady = true;
      }
    };

    loadData();
  }, [location.search]);

  if (loading) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        Loading Gantt...
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        No Gantt data available
      </div>
    );
  }

  return (
    <div className="w-screen h-screen overflow-hidden bg-white">
      <GanttChart
        items={items}
        projectName={projectName}
        asOnDate={asOnDate}
       // hideControls
         hideControls={false}
        initialExpandedIds={expandedIds}
        initialShowPlanned={showPlanned}
        initialShowActual={showActual}
        initialShowForecast={showForecast}
      />
    </div>
  );
}*/
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { GanttChart } from "./GanttChart";
import { GanttWorkItem } from "../../types/gantt";
import { ProjectAPI } from "../../api/apiClient";

type GanttPdfPayload = {
  frontendUrl?: string;
  projectName: string;
  asOnDate: string;
  showPlanned: boolean;
  showActual: boolean;
  showForecast: boolean;
  expandedIds: number[];
  items: GanttWorkItem[];
};

export default function GanttStandalone() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [items, setItems] = useState<GanttWorkItem[]>([]);
  const [projectName, setProjectName] = useState<string>("");
  const [asOnDate, setAsOnDate] = useState<string>("");
  const [showPlanned, setShowPlanned] = useState(true);
  const [showActual, setShowActual] = useState(true);
  const [showForecast, setShowForecast] = useState(true);
  const [expandedIds, setExpandedIds] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);
  const [printMode, setPrintMode] = useState(false);

  useEffect(() => {
    const raw = sessionStorage.getItem("ganttPrintData");

    if (raw) {
      try {
        const parsed = JSON.parse(raw) as GanttPdfPayload;

        setItems(parsed.items || []);
        setProjectName(parsed.projectName || "");
        setAsOnDate(parsed.asOnDate || "");
        setShowPlanned(parsed.showPlanned ?? true);
        setShowActual(parsed.showActual ?? true);
        setShowForecast(parsed.showForecast ?? true);
        setExpandedIds(parsed.expandedIds || []);
        setPrintMode(true);

        setLoading(false);
        (window as any).__ganttReady = true;
        return;
      } catch (err) {
        console.error("Invalid ganttPrintData", err);
      }
    }

    const projectId = params.get("projectId");
    const date = params.get("date");

    if (!projectId || !date) {
      setLoading(false);
      (window as any).__ganttReady = true;
      return;
    }

    setProjectName(params.get("projectName") || `Project ${projectId}`);
    setAsOnDate(date);
    setPrintMode(false);

    const loadData = async () => {
      try {
        const res = await ProjectAPI.getGantt(Number(projectId), date);
        setItems(res || []);
      } catch (err) {
        console.error("Gantt load failed", err);
      } finally {
        setLoading(false);
        (window as any).__ganttReady = true;
      }
    };

    loadData();
  }, [location.search, params]);

  if (loading) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        Loading Gantt...
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="w-screen h-screen flex items-center justify-center">
        No Gantt data available
      </div>
    );
  }

  return (
    <div className="w-screen h-screen overflow-hidden bg-white">
      <GanttChart
        items={items}
        projectName={projectName || "Project"}
        asOnDate={asOnDate}
        hideControls={printMode}
        printMode={printMode}
        initialExpandedIds={expandedIds}
        initialShowPlanned={showPlanned}
        initialShowActual={showActual}
        initialShowForecast={showForecast}
      />
    </div>
  );
}